// extracted by mini-css-extract-plugin
module.exports = {"Container":"Forms_Container__3ZVd4","Loading":"Forms_Loading__16TYn","NotFound":"Forms_NotFound__aGLui"};